import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.46536 7.74992L0.707031 6.99159L5.90703 1.79159H1.2487V0.708252H7.7487V7.20825H6.66536V2.54992L1.46536 7.74992Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }